import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_GET_REQUEST,
  CONFIDENTIAL_GET_SUCCESS,
  CONFIDENTIAL_GET_FAILURE,
  CONFIDENTIAL_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_GET_REQUEST:
      return state
        .set('isFetching', true)
    case CONFIDENTIAL_GET_SUCCESS:
      return state
        .set('confidential', fromJS(action.payload.employee_confidential))
        .set('isFetching', false)
    case CONFIDENTIAL_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONFIDENTIAL_GET_RESET:
      return state
        .delete('confidential')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-get-reducer.js